const STORAGE_KEY = 'clickaway_catalog_nav'

function read () {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

function write (data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (e) {}
}

/**
 * Guarda la ruta del catálogo y el scroll actual antes de abrir un producto.
 */
export function saveCatalogPosition (route) {
  if (!route) return
  const name = route.name
  // Solo guardar si venimos de una vista de catálogo / lista
  const catalogNames = ['Home', 'HomeShort', 'ProductosMobile', 'MesaQRProductos', 'MesaQR']
  if (!catalogNames.includes(name)) return

  write({
    name,
    params: { ...route.params },
    query: { ...(route.query || {}) },
    fullPath: route.fullPath,
    scrollY: window.scrollY || window.pageYOffset || 0,
    savedAt: Date.now()
  })
}

export function peekCatalogPosition () {
  return read()
}

export function clearCatalogPosition () {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {}
}

export function categoriaElementId (id) {
  return `categoria-${id}`
}

/**
 * Ubica una categoría (o subcategoría) dentro del árbol del catálogo.
 * index es la posición del padre, para poder mostrarla si está fuera del recorte inicial.
 */
export function resolverSeccionCategoria (categorias, id) {
  const sid = String(id)
  const list = Array.isArray(categorias) ? categorias : []
  for (let i = 0; i < list.length; i++) {
    const c = list[i]
    if (String(c.id) === sid) return { id: c.id, index: i, esSub: false }
    const sub = (c.subcategorias || []).find(s => String(s.id) === sid)
    if (sub) return { id: sub.id, parentId: c.id, index: i, esSub: true }
  }
  return null
}

/**
 * Lleva el scroll a la sección de la categoría.
 * Reintenta mientras las categorías de arriba terminan de cargar y empujan el bloque.
 */
export function scrollToCategoria (id, { retries = 16, delay = 250 } = {}) {
  let lastTop = null
  let stable = 0
  const tryScroll = (left) => {
    const el = document.getElementById(categoriaElementId(id))
    const visible = el && el.offsetParent !== null
    if (!visible) {
      if (left > 0) setTimeout(() => tryScroll(left - 1), delay)
      return
    }
    const top = el.getBoundingClientRect().top
    if (lastTop != null && Math.abs(top - lastTop) < 12) stable++
    else stable = 0
    lastTop = top
    el.scrollIntoView({ behavior: 'auto', block: 'start' })
    if (stable < 2 && left > 0) setTimeout(() => tryScroll(left - 1), delay)
  }
  tryScroll(retries)
}

/**
 * Restaura el scroll si hay una posición guardada para esta ruta.
 * Devuelve true si se programó la restauración.
 */
export function restoreCatalogScroll (route, { clear = true } = {}) {
  const data = read()
  if (!data || !route) return false
  if (data.name !== route.name) return false
  if (String(data.params && data.params.client) !== String(route.params && route.params.client)) return false

  const y = Number(data.scrollY) || 0
  const delays = [0, 80, 200, 450, 900, 1500]

  delays.forEach((delay, i) => {
    setTimeout(() => {
      window.scrollTo(0, y)
      if (clear && i === delays.length - 1) clearCatalogPosition()
    }, delay)
  })
  return true
}

/**
 * Navega de vuelta al catálogo guardado, o al fallback.
 * No usa history.back() cuando hay fallback explícito: en Android el historial
 * suele ser producto/cuenta/checkout y “atrás” no lleva a tiendas.
 */
export function goBackToCatalog (router, fallback) {
  const data = peekCatalogPosition()
  if (data && data.name) {
    return router.push({
      name: data.name,
      params: data.params || {},
      query: data.query || {}
    }).catch(() => {
      if (fallback) return router.push(fallback).catch(() => {})
    })
  }
  if (fallback) {
    return router.push(fallback).catch(() => {})
  }
  if (window.history.length > 1) {
    router.back()
  }
  return Promise.resolve()
}
